import { inject, Injectable } from '@angular/core';
import { DestinationControllerApiService } from '@lx/shared/api/services';
import { FetchDataObject, ProductsCatalogFetcher } from '@lx/ui/product-catalog/shared/models/products-catalog-fetcher-service.type';
import { map, Observable } from 'rxjs';
import { getLocale } from '@lx/shared/i18n';
import { getCompanyHeader } from '@lx/shared/tokens';
import { Country, GetAllCountriesParameters } from '@lx/shared/data-access/types';
import { Memoize } from '@lx/shared/utils-http';

@Injectable({
  providedIn: 'root',
})
export class CountryDataService implements ProductsCatalogFetcher<Country> {
  private readonly locale = getLocale();
  private readonly companyHeader = getCompanyHeader();

  private readonly destinationControllerApiService = inject(DestinationControllerApiService);

  @Memoize((parameters) => JSON.stringify(parameters))
  getAllCountriesWithParameters(parameters: GetAllCountriesParameters): Observable<Country[]> {
    return this.destinationControllerApiService
      .findDestinationCountriesByFilter(parameters, this.locale, this.companyHeader)
      .pipe(map((countries) => [...countries].sort((c1, c2) => c1.weight - c2.weight)));
  }

  getResults(parameters: FetchDataObject): Observable<Country[]> {
    const { courseLanguageCode, purposeCode, courseTypeCode } = parameters;
    return this.getAllCountriesWithParameters({ courseLanguageCode, purposeCode, courseTypeCode });
  }
}
